<template>
    <page>
        <module enable-flex>
            <m-search ref="search" @search="searchHandle">
                <c-form>
                    <c-form-item type="input" label="标题" name="name"></c-form-item>
                    <c-form-item type="datetime" label="发布时间" start-name="start_create_date" end-name="end_create_date"></c-form-item>
                    <c-form-item type="checkbox" label="状态" name="state" :options="stateOptions"></c-form-item>
                </c-form>
            </m-search>
            <m-operate>
                <c-button color="sys" icon="add" @click="navigateTo(`/stationed_operation_guide_add`)" power="b_stationed_operation_guide_edit">添加指南</c-button>
            </m-operate>

            <c-table ref="table" code="abstract_consultation">
                <c-table-column
                        label="标题"
                        name="name"
                        width="300"
                >
                </c-table-column>

                <c-table-column
                        label="发布时间"
                        name="create_date"
                        width="150"
                >
                </c-table-column>

                <c-table-column
                        label="是否启用"
                        name="state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.state==2"><span style="color:darkgreen">启用</span></span>
                        <span v-if="data.state!=2"><span style="color:#999999">禁用</span></span>
                    </template>
                </c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        @sort="sortHandle"
                        width="120"
                ></c-table-column>

                <c-table-column
                        type="button"
                        fixed="right"
                        label="操作"
                        width="150"
                >
                    <template v-slot="{data}">
                        <c-table-button power="b_stationed_operation_guide_view" @click="navigateTo(`/stationed_operation_guide_detail/${data.id}`)">查看</c-table-button>
                        <c-table-button power="b_stationed_operation_guide_edit" v-if="data.state == 1"  @click="updateState(2,data)">启用</c-table-button>
                        <c-table-button power="b_stationed_operation_guide_edit" v-if="data.state == 2"  @click="updateState(1,data)">禁用</c-table-button>
                        <c-table-button power="b_stationed_operation_guide_edit" @click="navigateTo(`/stationed_operation_guide_edit/${data.id}`)">编辑</c-table-button>
                        <c-table-button power="b_stationed_operation_guide_edit" @click="deleteHandle(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>
        </module>
    </page>
</template>

<script>
    var name = 'm_stationed_operation_guide';
    var urls = {
        list:'/abstract_consultation/list', //列表数据
        del:'/abstract_consultation/del', //删除
        sort:'/abstract_consultation/sort', //排序
        state:'/abstract_consultation/state', //启禁用
        recommend:'/abstract_consultation/recommend' //推荐
    }
    export default {
        name: name,

        data() {
            return {
                editState: false,
                stateOptions: [
                    {value:1,name:'禁用'},
                    {value:2,name:'启用'}
                ]
            }
        },

        mounted() {
            this.$refs.search.search();

            this.$bus.$on('m_stationed_operation_guide.update', page => {
                this.$refs.table.update(page);
            });
        },

        beforeDestroy() {
            this.$bus.$off('m_stationed_operation_guide.update');
        },

        methods: {
            searchHandle(data) {
                data.type_id=-1;
                this.$refs.table.load({
                    url: urls.list,
                    data
                });
            },

            editHandle(row) {
                this.editState = true;
                this._edit = row.data.id;
                this._resolve = data => {
                    row.update(data);
                };
                this.$refs.form.set(row.data);
                this.$refs.dialog.open();
            },

            updateState(type,val) {
                this.$confirm({
                    text: '确定要'+(type==2?'启用':'禁用')+'【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.state,
                            data: {id:val.id,state:type},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },


            deleteHandle(val) {

                this.$confirm({
                    text: '确定要删除【'+val.name+'】吗？',  // 提示内容,
                    buttonName: '确定',  // 确定按钮文字
                    cancelButton: true,  // 是否显示取消按钮
                    resolve: () => {
                        this.request({
                            url: urls.del,
                            data: {id:val.id},
                            loading: true,
                            success: data => {
                                this.$message({
                                    text: '操作成功',
                                    icon: 'success'
                                });
                                this.$refs.table.update();
                            }
                        });
                    },  // 确定按钮回调
                    cancel: () => {},  // 取消按钮回调
                });
            },


            sortHandle(row, type, next) {
                this.request({
                    url: urls.sort,
                    data: {
                        id: row.data.id,
                        parent_id: row.expandData.parent ? row.expandData.parent.data.id : 0,
                        type: ['top', 'bottom'].includes(type) ? type : '',
                        id1: type == 'up' ? row.prev().data.id : type == 'down' ? row.data.id : '',
                        id2: type == 'up' ? row.data.id : type == 'down' ? row.next().data.id : '',
                    },
                    loading: true,
                    success: data => {
                        next();
                    }
                });
            },

        }
    }
</script>
